import { connect } from 'react-redux';
import * as actions from 'embed/actions';
import reducers from 'embed/reducers';
import Button from 'embed/components/Button'

export default connect(reducers, actions)(Button);
